import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CreateUpdateCabin from "pages/vending/cabin/CreateUpdateCabin";
import React from "react";

const CabinCrudDialog = ({
  open,
  handleClose,
  m_id,
  number,
  cabin,
  setCurrentItem,
}) => {
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={() => {
        handleClose();
        setCurrentItem(null);
      }}
      heading={cabin ? "Update cabin" : "Create cabin"}
    >
      <Box sx={{ overflow: "hidden", padding: 2 }}>
        <CreateUpdateCabin m_id={m_id} number={number} cabin={cabin} />
      </Box>
    </CustomDialog>
  );
};

export default CabinCrudDialog;
